import type { ReactNode } from 'react';
import DesktopLayout from '../../../layout/DesktopLayout';
import BottomNav from '../../../BottomNav';
import { DESKTOP_QUERY, useMediaQuery } from '../../hooks/useMediaQuery';
import { MediaToasts } from '../ui/MediaToasts';
import '../../MediaManagement.css';

/** App frame for Media Management pages: desktop layout from 900px, bottom navigation below it. */
export function MediaManagementShell({ children }: { children: ReactNode }) {
  const isDesktop = useMediaQuery(DESKTOP_QUERY);
  if (!isDesktop) {
    return (
      <div className="mm-shell mm-shell-mobile">
        {children}
        <MediaToasts />
        <BottomNav />
      </div>
    );
  }
  return (
    <DesktopLayout>
      <div className="mm-shell">
        {children}
        <MediaToasts />
      </div>
    </DesktopLayout>
  );
}
